import { Box, Flex } from '@mantine/core';
import { FC } from 'react';

import { Icon } from '../Icon';
import { Burger } from './Burger';
import { Notifications } from './Notifications';
import { SearchBar } from './SearchBar';
import styles from './styles.module.css';
import { UserMenu } from './UserMenu';

type Props = {
  opened: boolean;
  toggle: () => void;
};

export const TopBar: FC<Props> = ({ opened, toggle }) => {
  return (
    <Box className={styles.topBar}>
      <Flex justify="space-between" align="center">
        <Box>
          <Flex align="center">
            <Burger opened={opened} toggle={toggle} />
            <Icon name="logo" className={styles.logo} />
          </Flex>
        </Box>
        <Box>
          <Flex align="center">
            <SearchBar placeholder="SEARCH IN THE CMS" />
            <Notifications />
            <UserMenu />
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
};
